import { CadastroGenerico } from "../../cad/cadastro-generico/cadastro-generico";

export class Pagamento {
    sequenciaPagamento?: number;
    idPagamento?: number | null;
    idOrigem?: number;
    desricaoOrigem?: string;
    idMeioPagamento?: number;
    valor: number;
    dataPagamento: Date | string;
    usuarioAlteracao?: number;
    dataHoraAlteracao?: Date;
    rowid?: string;
    meioPagamento?: CadastroGenerico;
}
